import { Post, Get, Patch, Put, Delete, Download, ax } from './http';
import { type } from './interface';
import qs from 'qs';
export namespace Goods {

    /**
    * 货物列表
    */
    export var getGoodsList = (query: any): Promise<any> => {
        return Get(`/csp/Goods/getGoodsList?${qs.stringify(query)}`, {});
    };


}

